import { Component, OnInit } from '@angular/core';
import { ProductReviewsComponent } from '@spartacus/storefront';

@Component({
  selector: 'app-custom-product-reviews',
  templateUrl: './custom-product-reviews.component.html',
  styleUrls: ['./custom-product-reviews.component.scss'],
  standalone: false
})
export class CustomProductReviewsComponent extends ProductReviewsComponent {

  initialMaxListItems = 2;
}
